import { createSlice } from "@reduxjs/toolkit";
// eslint-disable-next-line no-duplicate-imports
import type { PayloadAction } from "@reduxjs/toolkit";


interface RegisterState {
  recaptchaV2SiteKey?: string;
}

const initialState: RegisterState = {
};

const registerSlice = createSlice({
  name: "register",
  initialState,
  reducers: {
    openAcceptEmcModal(state) {
      return {
        ...state
      };
    },
    setRecaptchaV2SiteKey(state, action: PayloadAction<string>) {
      state.recaptchaV2SiteKey = action.payload;
    },
    destroy() {
      return initialState;
    }
  }
});


export default registerSlice.reducer;
export const { setRecaptchaV2SiteKey, destroy } = registerSlice.actions;
export const registerActions = registerSlice.actions;
